import { useTranslation } from 'react-i18next';
import styles from './Logo.module.css';

/**
 * Логотип Jisy: знак и леттеринг.
 *
 * Контуры сняты с макета логотипа, поэтому в коде они лежат готовыми путями и правке «на глаз»
 * не подлежат. Знак повторяет `client/public/favicon.svg`; цвета — из токенов, толщина «J» —
 * из CSS-модуля, чтобы значения не расходились с остальной вёрсткой.
 */

/** Плита знака: три угла скруглены, правый нижний прямой — он повторяет разворот «J». */
const PLATE = 'M 23 0 H 77 A 23 23 0 0 1 100 23 V 100 H 23 A 23 23 0 0 1 0 77 V 23 A 23 23 0 0 1 23 0 Z';

/** Осевая линия «J» внутри плиты: штрих, поворот влево, хвост. */
const GLYPH = 'M 67.7 26.3 V 51.8 A 21.7 21.7 0 0 1 46 73.5 H 30';

/** Слово «jisy» контурами. Точка над «j» вынесена отдельно — она единственная цветная. */
const WORD =
  // j
  'M 128.92 29.45 C 128.83 29.7, 128.72 42.8, 128.67 58.58 C 128.57 87.12, 128.57 87.26, 127.81 88.68 C 127.38 89.47, 126.73 90.39, 126.35 90.73 C 125.24 91.74, 122.73 92.45, 120.28 92.45 L 118 92.45 118 97.69 L 118 102.94 122.93 102.75 C 128.79 102.51, 131.56 101.77, 134.91 99.52 C 137.5 97.78, 139.42 95.25, 140.64 91.97 L 141.47 89.76 141.57 59.38 L 141.68 29.01 135.38 29.01 C 130.67 29.01, 129.05 29.12, 128.92 29.45' +
  // i
  'M 153.01 48.45 C 152.87 58.95, 152.77 70.72, 152.77 74.61 L 152.77 81.69 159.22 81.69 L 165.67 81.69 165.67 70.64 C 165.67 64.56, 165.56 52.79, 165.43 44.48 L 165.19 29.36 159.22 29.36 L 153.24 29.36 153.01 48.45' +
  // s
  'M 189.86 33.13 C 184.6 34.12, 180.96 35.93, 178.21 38.91 C 175.82 41.5, 175.17 43.29, 175.17 47.28 C 175.17 50.28, 175.29 50.91, 176.12 52.5 C 176.65 53.49, 177.8 54.97, 178.69 55.79 C 181.62 58.49, 184.78 59.73, 194.06 61.8 C 197.27 62.52, 200.88 63.43, 202.08 63.81 C 204.89 64.71, 206.34 66.14, 206.34 68.03 C 206.34 69.95, 205.35 71.22, 203.01 72.31 C 201.24 73.13, 200.51 73.25, 197.39 73.25 C 193.07 73.24, 190.73 72.55, 188.61 70.65 C 187.77 69.9, 186.93 68.71, 186.65 67.89 L 186.17 66.46 179.99 66.36 L 173.81 66.26 174.02 68.32 C 174.32 71.15, 176.34 75.16, 178.4 76.97 C 180.64 78.93, 184.3 80.77, 187.89 81.73 C 190.52 82.44, 191.79 82.55, 197.03 82.53 C 202.08 82.52, 203.62 82.38, 205.99 81.75 C 212.18 80.09, 216.29 77.11, 218.29 72.81 C 219.09 71.08, 219.24 70.26, 219.25 67.54 C 219.25 64.72, 219.13 64.05, 218.25 62.26 C 215.75 57.18, 211.25 55.03, 196.37 51.82 C 191.4 50.74, 189.16 49.76, 188.42 48.34 C 187.57 46.69, 187.76 45.53, 189.1 44.26 C 191.25 42.23, 195.36 41.5, 199.48 42.42 C 202.7 43.14, 204.83 44.54, 205.5 46.37 L 205.96 47.64 209.02 47.65 C 210.71 47.65, 213.44 47.75, 215.1 47.88 L 218.11 48.12 217.9 46.29 C 217.37 41.82, 214.06 37.59, 209.28 35.3 C 204.13 32.82, 196.19 31.93, 189.86 33.13' +
  // y
  'M 220.97 33.75 C 221.29 34.54, 233.15 61.08, 237.84 71.52 C 240.33 77.06, 242.37 81.77, 242.37 81.98 C 242.37 82.19, 241.89 83.61, 241.31 85.13 C 239.09 90.9, 237.41 92.16, 231.62 92.44 L 227.86 92.63 227.76 97.77 L 227.66 102.92 233.67 102.75 C 238.62 102.61, 240.06 102.44, 241.81 101.81 C 247.51 99.75, 250.18 96.68, 253.68 88.15 C 254.61 85.88, 259.53 74.1, 264.61 61.98 C 275.35 36.36, 276.42 33.78, 276.42 33.5 C 276.42 33.38, 273.33 33.33, 269.55 33.39 L 262.67 33.49 258.33 44.24 C 255.95 50.15, 253.05 57.33, 251.9 60.19 C 250.75 63.05, 249.62 65.75, 249.39 66.2 C 249.02 66.93, 248.74 66.44, 246.54 61.18 C 245.2 57.97, 242 50.39, 239.42 44.33 L 234.73 33.31 227.76 33.31 C 222.33 33.31, 220.83 33.41, 220.97 33.75';

/** Знак и слово: высота задаётся в пикселях, ширина считается по пропорции макета. */
export function Logo({
  height = 20,
  tone = 'brand',
}: {
  height?: number;
  /** `onColor` — вывернутый вариант для заливки (шапка и подвал экрана входа). */
  tone?: 'brand' | 'onColor';
}): React.ReactElement {
  const { t } = useTranslation();

  return (
    <svg
      className={tone === 'onColor' ? `${styles.logo} ${styles.onColor}` : styles.logo}
      viewBox="0 0 277 103"
      height={height}
      width={Math.round((height * 277) / 103)}
      role="img"
      aria-label={t('app.name')}
    >
      <path className={styles.plate} d={PLATE} />
      <path className={styles.glyph} d={GLYPH} />
      <rect className={styles.dot} x="128.75" y="7.5" width="13.1" height="13.1" />
      <path className={styles.word} d={WORD} fillRule="evenodd" />
    </svg>
  );
}

/** Один знак, без слова: для мест, где на строку логотипа не хватает ширины. */
export function LogoMark({ size = 18 }: { size?: number }): React.ReactElement {
  return (
    <svg
      className={styles.logo}
      viewBox="0 0 100 100"
      width={size}
      height={size}
      aria-hidden="true"
      focusable="false"
    >
      <path className={styles.plate} d={PLATE} />
      <path className={styles.glyph} d={GLYPH} />
    </svg>
  );
}
